import { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupPresentationProps, CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import { IconWrapper } from "@insite/mobius/Icon";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const checkbox: RecursivePartial<{
    defaultProps?: CheckboxPresentationProps | undefined;
    groupDefaultProps?:
        | (FieldSetGroupPresentationProps<CheckboxGroupProps> & CheckboxGroupPresentationProps)
        | undefined;
}> = {
    defaultProps: {
        color: colorStrings.commonGlobalWhite,
        indeterminateColor: colorStrings.commonGlobalWhite,
        mergeCss: true,
        css: css`
            ${IconWrapper} {
                &[role="checkbox"] {
                    border-radius: 4px;
                    border-color: ${getColor(colorStrings.commonGlobalBlack)};
                    margin: 0 0 1px;

                    &[aria-checked="true"],
                    &[aria-checked="mixed"] {
                        &:not([aria-disabled="true"]) {
                            border-color: ${getColor(colorStrings.primaryMain)};
                            background-color: ${getColor(colorStrings.primaryMain)};
                            color: ${getColor(colorStrings.commonGlobalWhite)};
                        }

                        & + label {
                            color: ${getColor(colorStrings.primaryMain)};
                            font-weight: 700;
                        }
                    }

                    &[aria-disabled="true"] {
                        background-color: ${getColor(colorStrings.commonGlobalWhite)};
                        border-color: ${getColor(colorStrings.commonGlobalGray04)};

                        & + label {
                            color: ${getColor(colorStrings.commonGlobalGray04)};
                        }
                    }
                }
            }

            label {
                font-size: 14px;
                line-height: 14px;
                ${mediaQueriesBP.minMD} {
                    font-size: 16px;
                    line-height: 16px;
                }
            }
        `,
    },
};
